import { MannequinProvider } from './context/MannequinContext';
import { MannequinForm } from './MannequinForm';

export const MannequinFormWrapper = () => {
    return (
        <MannequinProvider>
            <MannequinForm />
        </MannequinProvider>
    );
};

